// extracted by mini-css-extract-plugin
export default {"consoleTextArea":"consoleTextArea_consoleTextArea__JUPb9","promptToType":"consoleTextArea_promptToType__EcH0c","blinkingText":"consoleTextArea_blinkingText__3+m4C"};